import { offset } from "@floating-ui/react";
import { useCallback, useLayoutEffect, useRef } from "react";

import {
  useFloatingWindowOrder,
  useFloatingWindowsActions,
} from "src/base-components/FloatingWindow/hooks";
import { ManifestNodeBuilderWindowData } from "src/schema/window/ManifestNodeBuilderWindow";

const MANIFEST_NODE_BUILDER_WINDOW_ID = "manifest-node-builder";

export const useManifestNodeBuilderWindow = () => {
  const { open: openWindowInternal, close: closeWindowInternal } =
    useFloatingWindowsActions();
  const windowOrder = useFloatingWindowOrder(MANIFEST_NODE_BUILDER_WINDOW_ID);
  const windowTargetRef = useRef<HTMLDivElement | null>(null);

  const openWindow = useCallback(
    (data: ManifestNodeBuilderWindowData) => {
      openWindowInternal(
        {
          id: MANIFEST_NODE_BUILDER_WINDOW_ID,
          type: "manifest-node-builder",
          target: windowTargetRef,
          positionOptions: {
            placement: "right-start",
            middleware: [offset({ alignmentAxis: 10, mainAxis: 10 })],
          },
        },
        data,
      );
    },
    [openWindowInternal],
  );

  const closeWindow = useCallback(() => {
    closeWindowInternal(MANIFEST_NODE_BUILDER_WINDOW_ID);
  }, [closeWindowInternal]);

  useLayoutEffect(() => {
    const schemaEditor = document.querySelector("[data-loc=side-pane-schema]");
    windowTargetRef.current = schemaEditor as HTMLDivElement;
  }, []);

  return {
    openWindow,
    closeWindow,
    isOpen: !!windowOrder,
  };
};
